export default "__VITE_ASSET__D_pEf_rr__"